module.exports = __webpack_public_path__ + "static/media/experimentation-large@3x.1c0d12b0.png";